import { computed, makeObservable, observable, override } from 'mobx';

import { ProductType, TYPE_LGD_ROUGH, TYPE_ROUGH } from '../constants/productTypes';

import Product from './Product';

export default class Rough extends Product {
  width?: number;

  height?: number;

  length?: number;

  declare entityType: ProductType;

  constructor(...args: ConstructorParameters<typeof Product>) {
    super(...args);

    this.entityType = TYPE_ROUGH;

    makeObservable(this, {
      entityType: false,
      width: observable,
      height: observable,
      length: observable,
      dimensions: computed,
      type: override,
    });
  }

  get dimensions() {
    if (this.width && this.height && this.length) {
      return `${this.width}×${this.height}×${this.length}`;
    }

    return null;
  }

  get type(): ProductType {
    if (this.isLabGrown) {
      return TYPE_LGD_ROUGH;
    }

    return TYPE_ROUGH;
  }
}
